import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@/state'

import {
  authSelector,
  setSidebarIdsAction,
} from '@/state/auth/slices/index.slices'
import { SidebarId } from '@/enums/sidebar-id.enum'
import logoutThunk from '@/state/auth/thunk/logout.thunks'
import { setSidebarStatusAction } from '@/state/ui/global/slices/index.slices'

/**
 * useSidebarActions
 * @description This hook helps to set the sidebarIds depending the user role
 * @returns {sidebarIds, setSidebarIds, logout}
 */
const useSidebarActions = () => {
  const dispatch = useAppDispatch()

  const { sidebarIds } = useSelector(authSelector)

  const setSidebarIds = useCallback(
    (payload: SidebarId[]) => {
      dispatch(setSidebarIdsAction(payload))
    },
    [dispatch],
  )

  const setSidebarStatus = useCallback(
    (payload: boolean) => {
      dispatch(setSidebarStatusAction(payload))
    },
    [dispatch],
  )

  const logout = () => dispatch(logoutThunk())

  return {
    sidebarIds,
    setSidebarIds,
    logout,
    setSidebarStatus,
  }
}

export default useSidebarActions
